var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoBetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "var(--inputBg)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2170_48218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0003 3.66699C7.39796 3.66699 3.66699 7.39796 3.66699 12.0003C3.66699 16.6027 7.39796 20.3337 12.0003 20.3337C16.6027 20.3337 20.3337 16.6027 20.3337 12.0003C20.3337 7.39796 16.6027 3.66699 12.0003 3.66699ZM15.3858 11.5539C15.3743 11.5542 15.3627 11.5542 15.3512 11.5539H13.1907C12.7798 11.5539 12.4467 11.2208 12.4467 10.8098C12.4467 10.3989 12.7798 10.0658 13.1907 10.0658H14.0625C13.5463 9.51598 12.813 9.17294 12.0003 9.17294C10.4388 9.17294 9.17294 10.4388 9.17294 12.0003C9.17294 13.5618 10.4388 14.8277 12.0003 14.8277C13.0459 14.8277 13.9599 14.2605 14.4499 13.4135C14.6557 13.0578 15.1108 12.9362 15.4665 13.142C15.8222 13.3478 15.9438 13.8029 15.7381 14.1586C14.993 15.4466 13.5986 16.3158 12.0003 16.3158C9.61696 16.3158 7.68485 14.3837 7.68485 12.0003C7.68485 9.61696 9.61696 7.68485 12.0003 7.68485C13.0823 7.68485 14.0706 8.08287 14.8276 8.74005V8.4289C14.8276 8.01797 15.1608 7.68485 15.5717 7.68485C15.9826 7.68485 16.3157 8.01797 16.3157 8.4289V10.8098C16.3157 11.2208 15.9826 11.5539 15.5717 11.5539H15.3858Z",
    fill: "var(--selectBorder)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2170_48218)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "var(--primaryButtonBg)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoBetIcon);
export default __webpack_public_path__ + "static/media/auto-bet-icon.03efbdd48bd940668daa9d438521f740.svg";
export { ForwardRef as ReactComponent };